import React, { useState, useEffect } from 'react';
import {
	Cell,
	BarChart,
	Bar,
	XAxis,
	YAxis,
	CartesianGrid,
	Tooltip,
	Legend,
	ResponsiveContainer,
	LineChart,
	Line,
	LabelList,
	AreaChart,
	Area,
	PieChart,
	Pie,
} from 'recharts';
import TableLoading from '../../components/TableLoading';
import {
	mapTimeRangeToApiFilterAlt3Alt2,
	mapTimeRangeToApiFilterAlt3,
	request,
	formatCurrencyNew,
	formatHyphenatedText,
	formatCamelCaseToText,
} from '../../services/utilities';
import { analyticsAPI, analyticsAPIV2 } from '../../services/constants';
import AntenatalOverview from './AntenatalOverview';
import moment from 'moment';
import SlidingPane from '../../components/SlidingPane';
import { Card, Col, Row, Statistic } from 'antd';
import AnalysisBystaff from '../../components/Modals/frontDesk/staffAnalyticsmodal';
import IVFOverview from '../Nurse/IVFOverview';
import { TimeRangeDropdownAlt3 } from '../../components/TimeRangeDropdownAlt3';
import { cardColors, renderPieLabel } from '../FrontDesk/Overview';
import AdmissionOverview from '../Nurse/AdmissionAnalytics';
import ProcedureOverview from '../Procedure/Overview';
import TransactionMetrics from '../../components/charts/TransactionMetric';

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884d8', '#82ca9d', '#ff6e54', '#ffc0cb', '#faad14'];

export const CustomTooltipAlt2 = ({ active, payload, label }) => {
	if (active && payload && payload.length) {
		const data = payload[0].payload;
		return (
			<div
				className="custom-tooltip"
				style={{
					backgroundColor: '#fff',
					// border: '1px solid #ccc',
					padding: '8px',
					// borderRadius: '8px',
					fontSize: '13px',
					color: '#333',
				}}
			>
				<p style={{ marginBottom: '4px', fontWeight: 'bold' }} className="text-capitalize">
					{data?.name || 'Unknown'}
				</p>
				<p style={{ marginBottom: '2px' }} className="text-capitalize">
					Role: {data?.role || 'N/A'}
				</p>
				<p style={{ marginBottom: '2px' }}>Total Requests: {data?.total?.toLocaleString() || 0}</p>
				<p style={{ marginBottom: '0' }}>Total Created: {data?.totalCreated?.toLocaleString() || 0}</p>
				<p style={{ marginBottom: '0' }}>Total Changed: {data?.totalChanged?.toLocaleString() || 0}</p>
				<p style={{ marginBottom: '0' }}>Total Filled: {data?.totalFilled?.toLocaleString() || 0}</p>
				<p style={{ marginBottom: '0' }}>Total Received: {data?.totalReceived?.toLocaleString() || 0}</p>
				<p style={{ marginBottom: '0' }}>Total Approved: {data?.totalApproved?.toLocaleString() || 0}</p>
			</div>
		);
	}
	return null;
};

const DoctorOverview = () => {
	const [timeRanges, setTimeRanges] = useState({
		topDoctorsByConsultation: 'past30Days',
		consultationTrends: 'past30Days',
		topBottomDoctors: 'past30Days',
		topBottomProcedures: 'past30Days',
		procedureTrends: 'past30Days',
		departmentLoads: 'past30Days',
		specialtyLoads: 'past30Days',
		doctorEfficiency: 'past30Days',
		referralPatterns: 'past30Days',
		patientWaitTimes: 'past30Days',
		doctorAdmission: 'past30Days',
		admissionTrends: 'past30Days',
		dischargeTrends: 'past30Days',
		doctorsEncounter: 'past30Days',
		metrics: 'past30Days',
		dischargeCount: 'past30Days',
		admissionCount: 'past30Days',
		investigationCount: 'past30Days',
		encountersCount: 'past30Days',
		investigationAdmission: 'past30Days',
		investigationByDoctor: 'past30Days',
		investigationByHour: 'past30Days',
		staffRank: 'past30Days',
		transactionBreakdown: 'past30Days',
		appointmentTAT: 'past30Days',
		requestCount: 'past30Days',
	});

	const [loadingStates, setLoadingStates] = useState({
		metrics: false,
		consultationTrends: false,
		topBottomDoctors: false,
		topBottomProcedures: false,
		procedureTrends: false,
		departmentLoads: false,
		specialtyLoads: false,
		doctorEfficiency: false,
		referralPatterns: false,
		patientWaitTimes: false,
		doctorAdmission: false,
		admissionTrends: false,
		dischargeTrends: false,
		doctorsEncounter: false,
		dischargeCount: false,
		admissionCount: false,
		investigationCount: false,
		encountersCount: false,
		investigationAdmission: false,
		investigationByDoctor: false,
		investigationByHour: false,
		staffRank: false,
		transactionBreakdown: false,
		appointmentTAT: false,
		requestCount: false,
	});

	// Data states
	const [consultationTrends, setConsultationTrends] = useState([]);
	const [topDoctors, setTopDoctors] = useState([]);
	const [bottomDoctors, setBottomDoctors] = useState([]);

	const [topBottomProcedures, setTopBottomProcedures] = useState([]);
	const [procedureTrends, setProcedureTrends] = useState([]);
	const [departmentLoads, setDepartmentLoads] = useState([]);

	const [staffRankingTop, setStaffRankingTop] = useState([]);
	const [staffRankingBottom, setStaffRankingBottom] = useState([]);

	const [doctorAdmission, setDoctorAdmission] = useState([]);
	const [admissionTrends, setAdmissionTrends] = useState([]);
	const [dischargeTrends, setDisChargeTrends] = useState([]);
	const [doctorsEncounter, setDoctorsEncounter] = useState([]);
	const [dischargeCount, setDischargeCount] = useState(0);
	const [admissionCount, setAdmissionCount] = useState(0);
	const [investigationCount, setInvestigationCount] = useState(0);
	const [encountersCount, setEncountersCount] = useState(0);
	const [activeTab, setActiveTab] = useState('doctor');
	const [modal, setModal] = useState(false);
	const [staffRank, setStaffRank] = useState([]);
	const [modalAlt, setModalAlt] = useState(false);
	const [transactionsBreakdown, setTransactionsBreakdown] = useState();
	const [investigationAdmission, setInvestigationAdmission] = useState(false);
	const [investigationByDoctor, setInvestigationByDoctor] = useState(false);
	const [investigationByHour, setInvestigationByHour] = useState(false);
	const [appointmentTAT, setAppointmentTAT] = useState([]);
	const [requestCount, setRequestCount] = useState([]);
	const [modalOne, setModalOne] = useState(false);
	const [modalTwo, setModalTwo] = useState(false);

	const fetchInvestigationByDoctor = async range => {
		setLoadingStates(prev => ({ ...prev, investigationByDoctor: true }));
		const dateFilter = mapTimeRangeToApiFilterAlt3(range);
		try {
			const res = await request(`${analyticsAPI}/investigation-by-doctor?dateFilter=${dateFilter}`, 'GET', true);
			const apiResponse = Object.entries(res?.result)?.map(([name, count]) => ({
				name,
				count,
			}));

			setInvestigationByDoctor(apiResponse);
		} catch (error) {
			console.error('Failed to fetch data:', error);
		} finally {
			setLoadingStates(prev => ({ ...prev, investigationByDoctor: false }));
		}
	};

	const fetchInvestigationByHour = async range => {
		setLoadingStates(prev => ({ ...prev, investigationByHour: true }));
		const dateFilter = mapTimeRangeToApiFilterAlt3(range);
		try {
			const res = await request(`${analyticsAPI}/investigation-per-hour?dateFilter=${dateFilter}`, 'GET', true);
			const apiResponse = res?.result?.map(item => ({
				name: `${item?.hour}:00` || item?.date || item?.year || item?.month || 'Unknown',
				count: item?.count || 0,
			}));

			setInvestigationByHour(apiResponse);
		} catch (error) {
			console.error('Failed to fetch data:', error);
		} finally {
			setLoadingStates(prev => ({ ...prev, investigationByHour: false }));
		}
	};

	const investigationByAdmission = async range => {
		setLoadingStates(prev => ({ ...prev, investigationAdmission: true }));
		const dateFilter = mapTimeRangeToApiFilterAlt3(range);
		try {
			const res = await request(`${analyticsAPI}/investigation-admission?dateFilter=${dateFilter}`, 'GET', true);
			const apiResponse = res?.result?.map(item => ({
				name: item?.date || item?.year || item?.month || 'Unknown',
				count: item?.count || 0,
			}));
			setInvestigationAdmission(apiResponse);
		} catch (error) {
			console.error('Failed to fetch data:', error);
		} finally {
			setLoadingStates(prev => ({ ...prev, investigationAdmission: false }));
		}
	};

	const fetchDoctorAdmission = async range => {
		setLoadingStates(prev => ({ ...prev, doctorAdmission: true }));
		const dateFilter = mapTimeRangeToApiFilterAlt3(range);
		try {
			const res = await request(`${analyticsAPI}/doctor-admission?dateFilter=${dateFilter}`, 'GET', true);
			const apiResponse = Object.entries(res?.result)
				?.map(([name, count]) => ({
					name,
					count,
				}))
				.slice(0, 30);

			setDoctorAdmission(apiResponse);
		} catch (error) {
			console.error('Failed to fetch data:', error);
		} finally {
			setLoadingStates(prev => ({ ...prev, doctorAdmission: false }));
		}
	};

	const fetchAdmissionTrends = async range => {
		setLoadingStates(prev => ({ ...prev, admissionTrends: true }));
		const dateFilter = mapTimeRangeToApiFilterAlt3(range);
		try {
			const res = await request(`${analyticsAPI}/doctor-admission-trend?dateFilter=${dateFilter}`, 'GET', true);
			const apiResponse = res?.result?.map(x => ({
				name:
					x?.date ||
					(dateFilter == 'past-three-years' && x?.month && moment(x?.month).format('MMMM, YY')) ||
					(x?.month && moment(x?.month).format('MMMM')) ||
					x?.day ||
					x?.week ||
					x?.year ||
					x?.hour,
				count: parseInt(x?.count, 10),
			}));

			setAdmissionTrends(apiResponse);
		} catch (error) {
			console.error('Failed to fetch data:', error);
		} finally {
			setLoadingStates(prev => ({ ...prev, admissionTrends: false }));
		}
	};

	const fetchChargeTrends = async range => {
		setLoadingStates(prev => ({ ...prev, dischargeTrends: true }));
		const dateFilter = mapTimeRangeToApiFilterAlt3(range);
		try {
			const res = await request(`${analyticsAPI}/doctor-discharge-trend?dateFilter=${dateFilter}`, 'GET', true);
			const apiResponse = res?.result?.map(x => ({
				name:
					x?.date ||
					(dateFilter == 'past-three-years' && x?.month && moment(x?.month).format('MMMM, YY')) ||
					(x?.month && moment(x?.month).format('MMMM')) ||
					x?.day ||
					x?.week ||
					x?.year ||
					x?.hour,
				count: parseInt(x?.count, 10) || 0,
			}));

			setDisChargeTrends(apiResponse);
		} catch (error) {
			console.error('Failed to fetch data:', error);
		} finally {
			setLoadingStates(prev => ({ ...prev, dischargeTrends: false }));
		}
	};

	const fetchDoctorsEncounter = async range => {
		setLoadingStates(prev => ({ ...prev, doctorsEncounter: true }));
		const dateFilter = mapTimeRangeToApiFilterAlt3(range);
		try {
			const res = await request(`${analyticsAPI}/encounters-by-doctor?dateFilter=${dateFilter}`, 'GET', true);
			const apiResponse = Object.entries(res?.result)?.map(([name, count]) => ({
				name,
				count,
			}));

			setDoctorsEncounter(apiResponse);
		} catch (error) {
			console.error('Failed to fetch data:', error);
		} finally {
			setLoadingStates(prev => ({ ...prev, doctorsEncounter: false }));
		}
	};

	const fetchMetrics = async range => {
		setLoadingStates(prev => ({ ...prev, metrics: true }));
		const dateFilter = mapTimeRangeToApiFilterAlt3(range);

		try {
			const [dischargeRes, admissionRes, investigationRes, encountersRes] = await Promise.all([
				request(`${analyticsAPI}/doctor-discharge-count?dateFilter=${dateFilter}`, 'GET', true),
				request(`${analyticsAPI}/doctor-admission-count?dateFilter=${dateFilter}`, 'GET', true),
				request(`${analyticsAPI}/investigation-count?dateFilter=${dateFilter}`, 'GET', true),
				request(`${analyticsAPI}/encounters-count?dateFilter=${dateFilter}`, 'GET', true),
			]);

			setDischargeCount(dischargeRes?.result ?? 0);
			setAdmissionCount(admissionRes?.result ?? 0);
			setInvestigationCount(investigationRes?.result ?? 0);
			setEncountersCount(encountersRes?.result ?? 0);
		} catch (error) {
			console.error('Failed to fetch data:', error);
		} finally {
			setLoadingStates(prev => ({ ...prev, metrics: false }));
		}
	};

	const fetchConsultationTrends = async range => {
		setLoadingStates(prev => ({ ...prev, consultationTrends: true }));
		const dateFilter = mapTimeRangeToApiFilterAlt3(range);
		try {
			const res = await request(`analytics/appointment-consultation-type-trends?dateFilter=${dateFilter}`, 'GET', true);
			const apiResponse = res?.result;

			const formatedData = apiResponse?.map(item => ({
				date:
					item.day ||
					item.week ||
					(dateFilter == 'past-three-years' && moment(item?.month).format('MMM,YY')) ||
					(item.month && moment(item?.month).format('MMMM')) ||
					item.date ||
					item.year ||
					item?.hour,
				total: parseInt(item?.totalCount),
				initial: parseInt(item?.initialCount),
				follow_Up: parseInt(item?.followUpCount),
				review: parseInt(item?.reviewCount),
			}));
			setConsultationTrends(formatedData);
		} catch (error) {
			console.error('Failed to fetch consultation trends:', error);
		} finally {
			setLoadingStates(prev => ({ ...prev, consultationTrends: false }));
		}
	};

	const fetchTopBottomDoctors = async range => {
		setLoadingStates(prev => ({ ...prev, topBottomDoctors: true }));
		const dateFilter = mapTimeRangeToApiFilterAlt3(range);
		try {
			const res = await request(`analytics/procedure-doctors?dateFilter=${dateFilter}`, 'GET', true);

			const apiResponseTop = res?.top10?.map(x => ({
				name: x?.username,
				count: parseInt(x?.count, 10),
			}));

			const apiResponseBottom = res?.bottom10?.map(x => ({
				name: x?.username,
				count: parseInt(x?.count, 10),
			}));

			setTopDoctors(apiResponseTop);
			setBottomDoctors(apiResponseBottom);
		} catch (error) {
			console.error('Failed to fetch top/bottom doctors:', error);
		} finally {
			setLoadingStates(prev => ({ ...prev, topBottomDoctors: false }));
		}
	};

	const fetchDepartmentLoads = async range => {
		setLoadingStates(prev => ({ ...prev, departmentLoads: true }));
		const dateFilter = mapTimeRangeToApiFilterAlt3(range);
		try {
			const res = await request(`analytics/appointment-department-counts?dateFilter=${dateFilter}`, 'GET', true);

			const apiResponse = res?.result?.map(x => ({
				name: x?.departmentName,
				value: parseInt(x?.count, 10),
			}));

			setDepartmentLoads(apiResponse);
		} catch (error) {
			console.error('Failed to fetch department loads:', error);
		} finally {
			setLoadingStates(prev => ({ ...prev, departmentLoads: false }));
		}
	};

	const fetchProcedureTrends = async range => {
		setLoadingStates(prev => ({ ...prev, procedureTrends: true }));
		const dateFilter = mapTimeRangeToApiFilterAlt3(range);
		try {
			const res = await request(`analytics/procedure-trends?dateFilter=${dateFilter}`, 'GET', true);

			const apiResponse = res?.result?.map(x => ({
				name: x?.date || x?.day || x?.week || x?.month || x?.year,
				value: parseInt(x?.count, 10) || 0,
			}));

			setProcedureTrends(apiResponse);
		} catch (error) {
			console.error('Failed to fetch procedure trends:', error);
		} finally {
			setLoadingStates(prev => ({ ...prev, procedureTrends: false }));
		}
	};

	const fetchTopBottomProcedures = async range => {
		setLoadingStates(prev => ({ ...prev, topBottomProcedures: true }));
		const dateFilter = mapTimeRangeToApiFilterAlt3(range);
		try {
			const res = await request(`analytics/procedure-type?dateFilter=${dateFilter}`, 'GET', true);

			const apiResponse = res?.top10?.map(x => ({
				name: x?.name?.trim() || 'Unnamed Procedure',
				value: parseInt(x?.count, 10) || 0,
			}));

			setTopBottomProcedures(apiResponse);
		} catch (error) {
			console.error('Failed to fetch top/bottom procedures:', error);
		} finally {
			setLoadingStates(prev => ({ ...prev, topBottomProcedures: false }));
		}
	};

	const fetchTopAndBottom5 = async range => {
		setLoadingStates(prev => ({ ...prev, staffRanking: true }));
		const dateFilter = mapTimeRangeToApiFilterAlt3(range);
		try {
			const res = await request(`analytics/appointment-doctors?dateFilter=${dateFilter}`, 'GET', true);
			const apiResponseTop = res?.result?.map(x => ({
				name: x?.username ?? 'Unknown',
				count: parseInt(x?.count, 10),
			}));

			const apiResponseBottom = res?.result?.map(x => ({
				name: x?.username ?? 'Unknown',
				count: parseInt(x?.count, 10),
			}));
			setStaffRankingTop(apiResponseTop);
			setStaffRankingBottom(apiResponseBottom);
		} catch (error) {
			console.error('Failed to fetch staff rankings:', error);
		} finally {
			setLoadingStates(prev => ({ ...prev, staffRanking: false }));
		}
	};

	const fetchStaffRank = async range => {
		setLoadingStates(prev => ({ ...prev, staffRank: true }));
		try {
			const dateFilter = mapTimeRangeToApiFilterAlt3(range);
			const url = `analytics-v2/get-staff-request-count-by-role?roles=doctor:hmo-doctor:medical-director:ophthalmologist&dateFilter=${dateFilter}`;
			const res = await request(url, 'GET', true);
			const apiResponse = res?.map(x => ({
				...x,
				name: x?.username || 'unknown',
				role: x?.role,
			}));
			console.log(apiResponse, 'staff rank...');
			setStaffRank(apiResponse || []);
		} catch (error) {
			console.error('Failed to fetch staff rank:', error);
			setStaffRank([]);
		} finally {
			setLoadingStates(prev => ({ ...prev, staffRank: false }));
		}
	};

	const fetchTransactionsBreakdown = async range => {
		const dateFilter = mapTimeRangeToApiFilterAlt3(range);
		setLoadingStates(prev => ({ ...prev, transactionsBreakdown: true }));
		try {
			const res = await request(`analytics-v2/transaction-service-breakdown?type=doctor&dateFilter=${dateFilter}`, 'GET', true);
			const dataAlt = {
				total: [
					{ name: 'Self Pay Amount', value: Math.abs(res?.total?.selfPayAmount) || 0 },
					{ name: 'Self Pay Paid', value: Math.abs(res?.total?.nonSelfPayAmountPaid) || 0 },
					{ name: 'Non Self Pay Amount', value: Math.abs(res.total?.nonSelfPayAmount) || 0 },
					{ name: 'Non Self Pay Paid', value: Math.abs(res?.total?.nonSelfPayAmountPaid) || 0 },
				],

				summary: res?.summary?.map(({ billSource, selfPayAmount, selfPayAmountPaid, nonSelfPayAmount, nonSelfPayAmountPaid }) => ({
					item: billSource,
					data: [
						{ name: 'selfPayAmount', value: Math.abs(selfPayAmount || 0) },
						{ name: 'selfPay Paid', value: Math.abs(selfPayAmountPaid || 0) },
						{ name: 'nonSelfPayAmount', value: Math.abs(nonSelfPayAmount || 0) },
						{ name: 'nonSelfPay Paid', value: Math.abs(nonSelfPayAmountPaid || 0) },
					],
				})),
			};

			setTransactionsBreakdown(dataAlt);
		} catch (error) {
			console.error('Failed to fetch age range:', error);
		} finally {
			setLoadingStates(prev => ({ ...prev, transactionsBreakdown: false }));
		}
	};

	const fetchAppointmentTAT = async range => {
		setLoadingStates(prev => ({ ...prev, appointmentTAT: true }));
		const dateFilter = mapTimeRangeToApiFilterAlt3(range);
		try {
			const res = await request(`${analyticsAPIV2}/appointments/get-tat?dateFilter=${dateFilter}`, 'GET', true);
			const apiResponse = res?.map(x => ({
				...res,
				// time:x?.ave
			}));

			setAppointmentTAT(apiResponse);
		} catch (error) {
			console.error('Failed to fetch data:', error);
		} finally {
			setLoadingStates(prev => ({ ...prev, appointmentTAT: false }));
		}
	};

	const fetchStaffRequestCount = async range => {
		setLoadingStates(prev => ({ ...prev, requestCount: true }));
		try {
			const dateFilter = mapTimeRangeToApiFilterAlt3(range);
			const res = await request(`analytics-v2/staff-activity/request-count-trends?dateFilter=${dateFilter}&department=doctor`, 'GET', true);
			const apiResponse = res?.grouped?.map(x => ({
				name: x?.name,
				value: x?.count,
			}));
			setRequestCount(apiResponse);
		} catch (error) {
			console.error('Failed to fetch staff average activity time:', error);
			// setRequestCount([]);
		} finally {
			setLoadingStates(prev => ({ ...prev, requestCount: false }));
		}
	};

	useEffect(() => {
		fetchDoctorAdmission(timeRanges.doctorAdmission);
		fetchAdmissionTrends(timeRanges.admissionTrends);
		fetchChargeTrends(timeRanges.dischargeTrends);

		fetchDoctorsEncounter(timeRanges.doctorsEncounter);

		fetchMetrics(timeRanges.metrics);

		fetchInvestigationByDoctor(timeRanges.investigationByDoctor);
		fetchInvestigationByHour(timeRanges.investigationByHour);
		investigationByAdmission(timeRanges.investigationAdmission);

		fetchTopAndBottom5(timeRanges.topDoctorsByConsultation);
		fetchConsultationTrends(timeRanges.consultationTrends);
		fetchTopBottomDoctors(timeRanges.topBottomDoctors);
		fetchDepartmentLoads(timeRanges.departmentLoads);
		fetchProcedureTrends(timeRanges.procedureTrends);
		fetchTopBottomProcedures(timeRanges.topBottomProcedures);
		fetchStaffRank(timeRanges.staffRank);
		fetchTransactionsBreakdown(timeRanges.transactionBreakdown);
		fetchAppointmentTAT(timeRanges.appointmentTAT);
		fetchStaffRequestCount(timeRanges.requestCount);
	}, []);

	const handleTimeRangeChange = (range, chartId) => {
		setTimeRanges(prev => ({ ...prev, [chartId]: range }));

		switch (chartId) {
			case 'doctorAdmission':
				fetchDoctorAdmission(range);
				break;
			case 'doctorsEncounter':
				fetchDoctorsEncounter(range);
				break;
			case 'metrics':
				fetchMetrics(range);
				break;
			case 'admissionTrends':
				fetchAdmissionTrends(range);
				break;
			case 'investigationByDoctor':
				fetchInvestigationByDoctor(range);
				break;
			case 'dischargeTrends':
				fetchChargeTrends(range);
				break;
			case 'topDoctorsByConsultation':
				fetchTopAndBottom5(range);
				break;
			case 'consultationTrends':
				fetchConsultationTrends(range);
				break;
			case 'topBottomDoctors':
				fetchTopBottomDoctors(range);
				break;
			case 'departmentLoads':
				fetchDepartmentLoads(range);
				break;
			case 'procedureTrends':
				fetchProcedureTrends(range);
				break;
			case 'topBottomProcedures':
				fetchTopBottomProcedures(range);
				break;
			case 'staffRank':
				fetchStaffRank(range);
				break;
			case 'transactionsBreakdown':
				fetchTransactionsBreakdown(range);
				break;
			case 'appointmentTAT':
				fetchAppointmentTAT(range);
				break;
			case 'requestCount':
				fetchStaffRequestCount(range);
				break;
			default:
				break;
		}
	};

	const chartData = appointmentTAT?.groups?.map(group => ({
		name: group.name,
		Average: group.averageTAT.seconds,
		Median: group.medianTAT.seconds,
		Min: group.minTAT.seconds,
		Max: group.maxTAT.seconds,
	}));

	const renderCustomLabelAlt = ({ x, y, value, fill }) => {
		return (
			<text x={x} y={y} dy={-6} textAnchor="middle" fill={fill || '#333'} fontSize={12}>
				{value?.toLocaleString()}
			</text>
		);
	};

	const formatBarLabel = ({ x, y, value, width }) => (
		<text x={x + width / 2} y={y - 6} textAnchor="middle" fill="#333" fontSize={12}>
			{value?.toLocaleString()}
		</text>
	);

	const MetricsConfig = [
		{
			key: 'dischargeCount',
			label: 'Total Discharges',
			color: '#1890ff',
			value: dischargeCount,
		},
		{
			key: 'admissionCount',
			label: 'Total Admissions',
			color: '#52c41a',
			value: admissionCount,
		},
		{
			key: 'investigationCount',
			label: 'Total Investigations',
			color: '#faad14',
			value: investigationCount,
		},
		{
			key: 'encountersCount',
			label: 'Total Encounters',
			color: '#eb2f96',
			value: encountersCount,
		},
	];

	const MetricsCard = ({ value, label, color, loading }) => {
		const safeValue = Number(value) || 0;

		return (
			<div className="col-sm-4">
				<a className="element-box el-tablo" href="#">
					<Statistic
						title={label}
						value={loading ? <TableLoading /> : safeValue.toLocaleString()}
						valueStyle={{ fontWeight: 'bold', color }}
					/>
					<small className="text-muted">{label} for </small>
					<small className="text-muted">
						<strong>{formatHyphenatedText(mapTimeRangeToApiFilterAlt3(timeRanges?.metrics))}</strong>
					</small>
				</a>
			</div>
		);
	};

	const renderReport = () => {
		switch (activeTab) {
			case 'doctor':
				return (
					<div className="element-">
						<AnalysisBystaff module="doctors" slug="doctor" />

						{/* Overview Metrics */}
						<div className="row">
							<div className="col-sm-12">
								<div className="element-wrapper">
									<div className="d-flex justify-content-between align-items-center">
										<h6 className="element-header">Key Performance Indicators</h6>
										<TimeRangeDropdownAlt3 value={timeRanges?.metrics} onChange={handleTimeRangeChange} chartId="metrics" />
									</div>
									<p className="chart-description mb-3 p-2 card">
										Summary metrics showing overall clinic activity and doctor engagement levels.
									</p>
									{loadingStates.metrics ? (
										<TableLoading />
									) : (
										<div className="row">
											{MetricsConfig.map(({ key, label, color, value }) => (
												<MetricsCard key={key} label={label} color={color} value={value} loading={loadingStates?.metrics} />
											))}
										</div>
									)}
								</div>
							</div>
						</div>

						<TransactionMetrics module="doctor" />

						{/* doctor admission */}
						{/* <div className="row">
							<div className="col-sm-12">
								<div className="element-wrapper">
									<div className="d-flex justify-content-between align-items-center">
										<h6 className="element-header">Doctor Admission Overview</h6>
										<TimeRangeDropdownAlt3 value={timeRanges.doctorAdmission} onChange={handleTimeRangeChange} chartId="doctorAdmission" />
									</div>
									<p className="chart-description card p-2">
										Comprehensive analytics on doctor productivity, patient loads, and clinical operations.
									</p>
									<div className="element-box">
										{loadingStates.doctorAdmission ? (
											<TableLoading />
										) : doctorAdmission.length > 0 ? (
											<div style={{ height: '400px' }}>
												<ResponsiveContainer>
													<AreaChart data={doctorAdmission} margin={{ top: 20, right: 20, left: 10, bottom: 40 }}>
														<CartesianGrid strokeDasharray="3 3" />
														<XAxis
															dataKey={'name'}
															angle={-45}
															textAnchor="end"
															fontSize={12}
															interval={0}
															tickFormatter={value => {
																const truncated = value.length > 15 ? value.substring(0, 15) + '...' : value;
																const capitalized = truncated
																	.toLowerCase()
																	.split(' ')
																	.map(word => word.charAt(0).toUpperCase() + word.slice(1))
																	.join(' ');
																return capitalized;
															}}
														/>
														<YAxis domain={[0, 'auto']} />
														<Tooltip
															formatter={value => Number(value).toLocaleString()}
															labelFormatter={label => String(label).charAt(0).toUpperCase() + String(label).slice(1)}
														/>
														<Area
															type="monotone"
															dataKey="count"
															stroke="#0088FE"
															fill="#0088FE"
															strokeWidth={2}
															dot={{ r: 4 }}
															activeDot={{ r: 6 }}
														>
															<LabelList
																dataKey="count"
																content={renderCustomLabelAlt}
																position="top"
																style={{ fontSize: '12px', fill: '#333' }}
															/>
														</Area>
													</AreaChart>
												</ResponsiveContainer>
											</div>
										) : (
											<div className="text-center fs-bold">No Record Found!</div>
										)}
									</div>
								</div>
							</div>
						</div> */}

						{/*doctor admission trend  */}
						{/* <div className="row">
							<div className="col-sm-12">
								<div className="element-wrapper">
									<div className="d-flex justify-content-between align-items-center">
										<h6 className="element-header">Admission Trends</h6>
										<TimeRangeDropdownAlt3 value={timeRanges?.admissionTrends} onChange={handleTimeRangeChange} chartId="admissionTrends" />
									</div>
									<p className="chart-description card p-2">
										Comprehensive analytics on doctor productivity, patient loads, and clinical operations.
									</p>
									<div className="element-box">
										{loadingStates?.admissionTrends ? (
											<TableLoading />
										) : admissionTrends.length > 0 ? (
											<div style={{ height: '400px' }}>
												<ResponsiveContainer>
													<BarChart data={admissionTrends} margin={{ top: 20, right: 20, left: 20, bottom: 45 }}>
														<CartesianGrid strokeDasharray="3 3" />
														<XAxis
															dataKey={'name'}
															angle={-45}
															textAnchor="end"
															fontSize={12}
															interval={timeRanges.admissionTrends === 'pastQuarter' ? 2 : 0}
															tickFormatter={value => {
																const truncated = value.length > 15 ? value.substring(0, 15) + '...' : value;
																const capitalized = truncated
																	.toLowerCase()
																	.split(' ')
																	.map(word => word.charAt(0).toUpperCase() + word.slice(1))
																	.join(' ');
																return capitalized;
															}}
														/>
														<YAxis domain={[0, 'auto']} />
														<Tooltip
															formatter={value => Number(value).toLocaleString()}
															labelFormatter={label => String(label).charAt(0).toUpperCase() + String(label).slice(1)}
														/>
														<Bar dataKey="count">
															{admissionTrends.map((entry, index) => (
																<Cell key={`cell-eff-${index}`} fill={COLORS[(index + 2) % COLORS.length]} />
															))}
															<LabelList
																dataKey="count"
																content={formatBarLabel}
																position="top"
																style={{ fontSize: '12px', fill: '#333' }}
															/>
														</Bar>
													</BarChart>
												</ResponsiveContainer>
											</div>
										) : (
											<div className="text-center fs-bold">No Record Found!</div>
										)}
									</div>
								</div>
							</div>
						</div> */}

						{/*Staff Rank */}
						<div className="col-12 mt-4">
							<div className="element-wrapper">
								<h6 className="element-header">Staff Request Ranking</h6>

								<div className="d-flex justify-content-end w-100">
									<div>
										<div
											style={{ width: '100px', cursor: 'pointer', textAlign: 'center' }}
											onClick={() => setModalOne(true)}
											className="form-control form-control-sm text-white bg-primary rounded"
										>
											View All
										</div>
									</div>
									&nbsp;
									<TimeRangeDropdownAlt3 chartId="staffRank" onChange={handleTimeRangeChange} value={timeRanges?.staffRank} />
								</div>

								<p className="chart-description card p-2" style={{ fontSize: '14px', color: '#666', marginBottom: '10px' }}>
									The Staff Request Ranking by Role chart highlights the distribution and frequency of staff requests across different job
									roles, helping identify which roles generate the highest number of requests based on the selected filter.
								</p>
								<div className="row">
									<div className="col-md-12 mb-4">
										<div className="card">
											{loadingStates.staffRank ? (
												<TableLoading />
											) : staffRank ? (
												<div style={{ width: '100%', height: 400 }}>
													<ResponsiveContainer>
														<LineChart
															data={staffRank.slice(0, 30)}
															layout="horizontal"
															margin={{ top: 20, right: 20, left: 20, bottom: 55 }}
														>
															<CartesianGrid strokeDasharray="3 3" />
															<XAxis
																dataKey={'name'}
																angle={-45}
																textAnchor="end"
																fontSize={12}
																interval={0}
																tickFormatter={value => {
																	const truncated = value.length > 10 ? value.substring(0, 10) + '...' : value;
																	const capitalized = truncated
																		.toLowerCase()
																		.split(' ')
																		.map(word => word.charAt(0).toUpperCase() + word.slice(1))
																		.join(' ');
																	return capitalized;
																}}
															/>
															<YAxis domain={[0, 'auto']} />
															<Tooltip />

															<Line type="monotone" dataKey="total" stroke="#22BB33" strokeWidth={2} dot={{ r: 2 }} activeDot={{ r: 4 }}>
																{/* <LabelList/> */}
															</Line>
														</LineChart>
													</ResponsiveContainer>
												</div>
											) : (
												<div className="text-center fs-bold">No Record Found!</div>
											)}
										</div>
									</div>
								</div>
							</div>
							<SlidingPane isOpen={modalOne}>
								<div className=" content-box">
									<div className=" d-flex justify-content-end w-100">
										<button className="btn btn-danger float-end" onClick={() => setModalOne(false)}>
											&times;
										</button>
									</div>

									<div className=" d-flex justify-content-end mt-5 t-5 align-items-center">
										<TimeRangeDropdownAlt3 value={timeRanges.staffRank} onChange={handleTimeRangeChange} chartId="staffRank" />
									</div>
									<div className="row  w-100 " style={{ paddingLeft: '50px', paddingRight: '50px' }}>
										<div className="col-sm-12">
											<div className="element-wrapper">
												<h6 className="element-header">Staff Request Ranking</h6>
											</div>
										</div>
									</div>

									<div className=" " style={{ marginLeft: '50px', marginRight: '50px' }}>
										<p className="chart-description card p-2">
											The Staff Request Ranking by Role chart highlights the distribution and frequency of staff requests across different
											job roles, helping identify which roles generate the highest number of requests based on the selected filter.
										</p>
									</div>

									<div className=" " style={{ marginLeft: '50px', marginRight: '50px' }}>
										<div className=" card w-100 ">
											<div className="row">
												<div className="col-md-12 mb-4">
													<div className="card h-100">
														<div className="card-body">
															{loadingStates.staffRank ? (
																<TableLoading />
															) : staffRank ? (
																<div style={{ width: '100%', height: 400 }}>
																	<ResponsiveContainer>
																		<LineChart data={staffRank} layout="horizontal" margin={{ top: 20, right: 20, left: 20, bottom: 55 }}>
																			<CartesianGrid strokeDasharray="3 3" />
																			<XAxis
																				dataKey={'name'}
																				angle={-45}
																				textAnchor="end"
																				fontSize={12}
																				interval={2}
																				tickFormatter={value => {
																					const truncated = value.length > 10 ? value.substring(0, 10) + '...' : value;
																					const capitalized = truncated
																						.toLowerCase()
																						.split(' ')
																						.map(word => word.charAt(0).toUpperCase() + word.slice(1))
																						.join(' ');
																					return capitalized;
																				}}
																			/>
																			<YAxis domain={[0, 'auto']} />
																			<Tooltip content={<CustomTooltipAlt2 />} />

																			<Line
																				type="monotone"
																				dataKey="total"
																				stroke="#22BB33"
																				strokeWidth={2}
																				dot={{ r: 2 }}
																				activeDot={{ r: 4 }}
																			></Line>
																		</LineChart>
																	</ResponsiveContainer>
																</div>
															) : (
																<div className="text-center fs-bold">No Record Found!</div>
															)}
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</SlidingPane>
						</div>

						{/*doctor discharge trend  */}
						<div className="row">
							<div className="col-sm-12">
								<div className="element-wrapper">
									<div className="d-flex justify-content-between align-items-center">
										<h6 className="element-header">Doctor Discharge Trends</h6>
										<TimeRangeDropdownAlt3 value={timeRanges?.dischargeTrends} onChange={handleTimeRangeChange} chartId="dischargeTrends" />
									</div>
									<p className="chart-description card p-2">
										This charts shows the cumulative discharge trends over time, providing insights into patient flow and discharge rates.
									</p>
									<div className="element-box">
										{loadingStates.dischargeTrends ? (
											<TableLoading />
										) : dischargeTrends.length > 0 ? (
											<div style={{ height: '400px' }}>
												<ResponsiveContainer>
													<LineChart data={dischargeTrends} margin={{ top: 20, right: 20, left: 10, bottom: 40 }}>
														<CartesianGrid strokeDasharray="3 3" />
														<XAxis
															dataKey={'name'}
															angle={-45}
															textAnchor="end"
															fontSize={12}
															interval={timeRanges.dischargeTrends === 'pastQuarter' ? 2 : 0}
															tickFormatter={value => {
																const truncated = value.length > 15 ? value.substring(0, 15) + '...' : value;
																const capitalized = truncated
																	.toLowerCase()
																	.split(' ')
																	.map(word => word.charAt(0).toUpperCase() + word.slice(1))
																	.join(' ');
																return capitalized;
															}}
														/>
														<YAxis domain={[0, 'auto']} />
														<Tooltip
															formatter={value => Number(value).toLocaleString()}
															labelFormatter={label => String(label).charAt(0).toUpperCase() + String(label).slice(1)}
														/>
														{/* <Legend wrapperStyle={{ marginBottom: '-50px' }} /> */}
														<Line type="monotone" dataKey="count" stroke="#22BB33" strokeWidth={2} dot={{ r: 4 }} activeDot={{ r: 6 }}>
															<LabelList
																dataKey="count"
																content={renderCustomLabelAlt}
																position="top"
																style={{ fontSize: '10px', fill: '#333' }}
															/>
														</Line>
													</LineChart>
												</ResponsiveContainer>
											</div>
										) : (
											<div className="text-center fs-bold">No Record Found!</div>
										)}
									</div>
								</div>
							</div>
						</div>

						{/*doctor encounters  */}
						<div className="row">
							<div className="col-sm-12 ">
								<div className="element-wrapper">
									<div className="d-flex justify-content-between align-items-center">
										<h6 className="element-header">Doctor's Encounter Trends</h6>

										<div className="d-flex justify-content-end w-100">
											<div>
												<div
													style={{ width: '100px', cursor: 'pointer', textAlign: 'center' }}
													onClick={() => setModalTwo(true)}
													className="form-control form-control-sm text-white bg-primary rounded"
												>
													View All
												</div>
											</div>
											&nbsp;
											<TimeRangeDropdownAlt3
												value={timeRanges?.doctorsEncounter}
												onChange={handleTimeRangeChange}
												chartId="doctorsEncounter"
											/>
										</div>

										{/* <div className="d-flex justify-content-between align-items-center w-100">
											<TimeRangeDropdownAlt3
											value={timeRanges?.doctorsEncounter}
											onChange={handleTimeRangeChange}
											chartId="doctorsEncounter"
										/>
										<div
											style={{ width: '100px', cursor: 'pointer', textAlign: 'center' }}
											// onClick={() => setModalAlt(true)}
											className="form-control form-control-sm text-white bg-primary rounded"
										>
											View All
										</div>
									</div> */}
									</div>
									<p className="chart-description card p-2">
										This charts shows the number of encounters per doctor over the selected time period, helping to identify workload
										distribution and patient interaction levels.
									</p>
									<div className="element-box">
										{loadingStates.doctorsEncounter ? (
											<TableLoading />
										) : doctorsEncounter.length > 0 ? (
											<div style={{ height: '400px' }}>
												<ResponsiveContainer>
													<AreaChart data={doctorsEncounter.slice(0, 15)} margin={{ top: 20, right: 20, left: 10, bottom: 40 }}>
														<CartesianGrid strokeDasharray="3 3" />
														<XAxis
															dataKey={'name'}
															angle={-45}
															textAnchor="end"
															fontSize={12}
															interval={2}
															tickFormatter={value => {
																const truncated = value.length > 15 ? value.substring(0, 15) + '...' : value;
																const capitalized = truncated
																	.toLowerCase()
																	.split(' ')
																	.map(word => word.charAt(0).toUpperCase() + word.slice(1))
																	.join(' ');
																return capitalized;
															}}
														/>
														<YAxis domain={[0, 'auto']} />
														<Tooltip
															formatter={value => Number(value).toLocaleString()}
															labelFormatter={label => String(label).charAt(0).toUpperCase() + String(label).slice(1)}
														/>
														{/* <Legend wrapperStyle={{ marginBottom: '-45px' }} /> */}
														<Area
															type="monotone"
															dataKey="count"
															stroke="#8884d8"
															fill="#8884d8"
															strokeWidth={2}
															dot={{ r: 4 }}
															activeDot={{ r: 6 }}
														>
															<LabelList
																dataKey="count"
																content={renderCustomLabelAlt}
																position="top"
																style={{ fontSize: '12px', fill: '#333' }}
															/>
														</Area>
													</AreaChart>
												</ResponsiveContainer>
											</div>
										) : (
											<div className="text-center fs-bold">No Record Found!</div>
										)}
									</div>
								</div>
							</div>

							<SlidingPane isOpen={modalTwo}>
								<div className=" content-box">
									<div className=" d-flex justify-content-end w-100">
										<button className="btn btn-danger float-end" onClick={() => setModalTwo(false)}>
											&times;
										</button>
									</div>

									<div className=" d-flex justify-content-end mt-5 t-5 align-items-center">
										<TimeRangeDropdownAlt3
											value={timeRanges.doctorsEncounter}
											onChange={handleTimeRangeChange}
											chartId="doctorsEncounter"
										/>
									</div>
									<div className="row  w-100 " style={{ paddingLeft: '50px', paddingRight: '50px' }}>
										<div className="col-sm-12">
											<div className="element-wrapper">
												<h6 className="element-header">Doctor's Encounter Trends</h6>
											</div>
										</div>
									</div>

									<div className=" " style={{ marginLeft: '50px', marginRight: '50px' }}>
										<p className="chart-description card p-2">
											This charts shows the number of encounters per doctor over the selected time period, helping to identify workload
											distribution and patient interaction levels.
										</p>
									</div>

									<div className=" " style={{ marginLeft: '50px', marginRight: '50px' }}>
										<div className=" card w-100 ">
											<div className="row">
												<div className="col-md-12 mb-4">
													<div className="card h-100">
														<div className="card-body">
															{loadingStates.doctorsEncounter ? (
																<TableLoading />
															) : doctorsEncounter ? (
																<div style={{ width: '100%', height: 400 }}>
																	<ResponsiveContainer>
																		<AreaChart data={doctorsEncounter} margin={{ top: 20, right: 20, left: 10, bottom: 40 }}>
																			<CartesianGrid strokeDasharray="3 3" />
																			<XAxis
																				dataKey={'name'}
																				angle={-45}
																				textAnchor="end"
																				fontSize={12}
																				interval={2}
																				tickFormatter={value => {
																					const truncated = value.length > 15 ? value.substring(0, 15) + '...' : value;
																					const capitalized = truncated
																						.toLowerCase()
																						.split(' ')
																						.map(word => word.charAt(0).toUpperCase() + word.slice(1))
																						.join(' ');
																					return capitalized;
																				}}
																			/>
																			<YAxis domain={[0, 'auto']} />
																			<Tooltip
																				formatter={value => Number(value).toLocaleString()}
																				labelFormatter={label => String(label).charAt(0).toUpperCase() + String(label).slice(1)}
																			/>
																			{/* <Legend wrapperStyle={{ marginBottom: '-45px' }} /> */}
																			<Area
																				type="monotone"
																				dataKey="count"
																				stroke="#8884d8"
																				fill="#8884d8"
																				strokeWidth={2}
																				dot={{ r: 4 }}
																				activeDot={{ r: 6 }}
																			>
																				<LabelList
																					dataKey="count"
																					content={renderCustomLabelAlt}
																					position="top"
																					style={{ fontSize: '12px', fill: '#333' }}
																				/>
																			</Area>
																		</AreaChart>
																	</ResponsiveContainer>
																</div>
															) : (
																<div className="text-center fs-bold">No Record Found!</div>
															)}
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</SlidingPane>
						</div>

						{/* Consultation Trends */}
						<div className="row">
							<div className="col-sm-12">
								<div className="element-wrapper">
									<div className="d-flex justify-content-between align-items-center">
										<h6 className="element-header">Consultation Volume Trends</h6>
										<TimeRangeDropdownAlt3
											value={timeRanges.consultationTrends}
											onChange={handleTimeRangeChange}
											chartId="consultationTrends"
										/>
									</div>
									<p className="chart-description mb-3 p-2 card">
										Tracking consultation patterns over time to identify peak periods and seasonal variations.
									</p>
									<div className="element-box">
										{loadingStates?.consultationTrends ? (
											<TableLoading />
										) : consultationTrends?.length > 0 ? (
											<div style={{ height: '400px' }}>
												<ResponsiveContainer>
													<AreaChart data={consultationTrends} margin={{ top: 20, right: 30, left: 20, bottom: 40 }}>
														<CartesianGrid strokeDasharray="3 3" />
														<XAxis
															dataKey={'date'}
															angle={-45}
															textAnchor="end"
															fontSize={12}
															interval={timeRanges?.consultationTrends == 'pastQuarter' ? 2 : 0}
															tickFormatter={value => {
																const truncated = value.length > 15 ? value.substring(0, 15) + '...' : value;
																const capitalized = truncated
																	.toLowerCase()
																	.split(' ')
																	.map(word => word.charAt(0).toUpperCase() + word.slice(1))
																	.join(' ');
																return capitalized;
															}}
														/>
														<YAxis domain={[0, 'auto']} />
														<Tooltip content={<CustomTooltipAlt />} />
														{/* <Legend wrapperStyle={{ marginBottom: '-50px' }} /> */}
														<Area
															type="monotone"
															dataKey="initial"
															stroke="#8884d8"
															fill="#8884d8"
															fillOpacity={0.2}
															name="initial"
															strokeWidth={2}
															dot={{ r: 4 }}
															activeDot={{ r: 6 }}
														>
															<LabelList
																dataKey="initial"
																position="top"
																content={renderCustomLabelAlt}
																style={{ fontSize: '12px', fill: '#333' }}
															/>
														</Area>
														<Area
															type="monotone"
															dataKey="follow_Up"
															stroke="#82ca9d"
															fill="#82ca9d"
															fillOpacity={0.2}
															name="Follow-up"
															strokeWidth={2}
															dot={{ r: 4 }}
															activeDot={{ r: 6 }}
														>
															<LabelList
																dataKey="follow_up"
																position="top"
																content={renderCustomLabelAlt}
																style={{ fontSize: '12px', fill: '#333' }}
															/>
														</Area>
														{/* <Area
															type="monotone"
															dataKey="review"
															stroke="red"
															fill="red"
															fillOpacity={0.2}
															name="review"
															strokeWidth={2}
															dot={{ r: 4 }}
															activeDot={{ r: 6 }}
														>
															<LabelList
																dataKey="review"
																position="top"
																content={renderCustomLabelAlt}
																style={{ fontSize: '12px', fill: '#333' }}
															/>
														</Area> */}
													</AreaChart>
												</ResponsiveContainer>
											</div>
										) : (
											<div className="text-center fs-bold">No Record Found!</div>
										)}
									</div>
								</div>
							</div>
						</div>

						{/* Top/Bottom Doctors */}
						<div className="row">
							<div className="row col-12">
								<div className="col-sm-12 col-lg-">
									<div className="element-wrapper">
										<h6 className="element-header">Consultation Ranking by Staff</h6>
										<h6>Top (Highest)</h6>
										<div className="d-flex justify-content-end mb-5 w-100">
											<div className="d-flex justify-content-end w-100">
												<div>
													<div
														style={{ width: '100px', cursor: 'pointer', textAlign: 'center' }}
														onClick={() => setModal(true)}
														className="form-control form-control-sm text-white bg-primary rounded"
													>
														View All
													</div>
												</div>
												&nbsp;
												<TimeRangeDropdownAlt3
													value={timeRanges.topDoctorsByConsultation}
													onChange={handleTimeRangeChange}
													chartId="topDoctorsByConsultation"
												/>
											</div>
											{/* <TimeRangeDropdownAlt3 value={timeRanges.staffRanking} onChange={handleTimeRangeChange} chartId="staffRanking" /> */}
										</div>
										<p className="chart-description card p-2" style={{ fontSize: '14px', color: '#666', marginBottom: '10px' }}>
											This chart ranks Doctors by their total consultations over the selected time period, highlighting top performers.
										</p>
										<div className="card">
											{loadingStates.staffRanking ? (
												<TableLoading />
											) : staffRankingTop?.length > 0 ? (
												<div style={{ width: '100%', height: 400 }}>
													<ResponsiveContainer width="100%" height={400}>
														<BarChart data={staffRankingTop?.slice(0, 10)} margin={{ top: 20, right: 30, left: 20, bottom: 40 }}>
															<CartesianGrid strokeDasharray="5 5" />
															<XAxis
																dataKey={'name'}
																angle={-45}
																textAnchor="end"
																fontSize={12}
																interval={0}
																tickFormatter={value => {
																	const truncated = value.length > 15 ? value.substring(0, 15) + '...' : value;
																	const capitalized = truncated
																		.toLowerCase()
																		.split(' ')
																		.map(word => word.charAt(0).toUpperCase() + word.slice(1))
																		.join(' ');
																	return capitalized;
																}}
															/>
															<YAxis domain={[0, 'auto']} />
															<Tooltip
																formatter={value => Number(value).toLocaleString()}
																labelFormatter={label => String(label).charAt(0).toUpperCase() + String(label).slice(1)}
															/>
															{/* <Legend wrapperStyle={{ marginBottom: '-45px' }} /> */}

															<Bar dataKey="count">
																{staffRankingTop.map((entry, index) => (
																	<Cell key={`cell-${index}`} fill={COLORSe[entry.type] || 'blue'} />
																))}
																<LabelList dataKey="count" position="top" content={formatBarLabel} />
															</Bar>
														</BarChart>
													</ResponsiveContainer>
												</div>
											) : (
												<div className="text-center fs-bold">No Record Found!</div>
											)}
										</div>
									</div>
								</div>

								<div className="col-sm-12 col-lg-">
									<div className="element-wrapper mt-4">
										{/* <h6 className="element-header"> </h6> */}
										<h6>Bottom (Lowest)</h6>
										<div className="d-flex justify-content-end w-100">
											<div className="d-flex justify-content-end w-100">
												<div>
													<div
														style={{ width: '100px', cursor: 'pointer', textAlign: 'center' }}
														onClick={() => setModal(true)}
														className="form-control form-control-sm text-white bg-primary rounded"
													>
														View All
													</div>
												</div>
												&nbsp;
												<TimeRangeDropdownAlt3
													value={timeRanges.topDoctorsByConsultation}
													onChange={handleTimeRangeChange}
													chartId="topDoctorsByConsultation"
												/>
											</div>
										</div>
										<p className="chart-description card p-2" style={{ fontSize: '14px', color: '#666', marginBottom: '10px' }}>
											This chart shows staff with the lowest performing doctors by consultations, helping identify areas for improvement.
										</p>
										<div className="card">
											{loadingStates.staffRanking ? (
												<TableLoading />
											) : staffRankingBottom?.length > 0 ? (
												<div style={{ width: '100%', height: 400 }}>
													<ResponsiveContainer width="100%" height={400}>
														<BarChart data={staffRankingBottom?.slice(-10)} margin={{ top: 20, right: 30, left: 20, bottom: 40 }}>
															<CartesianGrid strokeDasharray="5 5" />
															<XAxis
																dataKey={'name'}
																angle={-45}
																textAnchor="end"
																fontSize={12}
																interval={0}
																tickFormatter={value => {
																	const truncated = value.length > 15 ? value.substring(0, 15) + '...' : value;
																	const capitalized = truncated
																		.toLowerCase()
																		.split(' ')
																		.map(word => word.charAt(0).toUpperCase() + word.slice(1))
																		.join(' ');
																	return capitalized;
																}}
															/>
															<YAxis domain={[0, 'auto']} />
															<Tooltip
																formatter={value => Number(value).toLocaleString()}
																labelFormatter={label => String(label).charAt(0).toUpperCase() + String(label).slice(1)}
															/>
															{/* <Legend wrapperStyle={{ marginBottom: '-45px' }} /> */}
															<Bar dataKey="count">
																{staffRankingBottom.map((entry, index) => (
																	<Cell key={`cell-${index}`} fill={COLORSe[entry.type] || 'blue'} />
																))}
																<LabelList dataKey="count" position="top" content={formatBarLabel} />
															</Bar>
														</BarChart>
													</ResponsiveContainer>
												</div>
											) : (
												<div className="text-center fs-bold">No Record Found!</div>
											)}
										</div>
									</div>
									<SlidingPane isOpen={modal}>
										<div className=" content-box">
											<div className=" d-flex justify-content-end w-100">
												<button className="btn btn-danger float-end" onClick={() => setModal(false)}>
													&times;
												</button>
											</div>

											<div className=" d-flex justify-content-end mt-5 t-5 align-items-center">
												<TimeRangeDropdownAlt3
													value={timeRanges.topDoctorsByConsultation}
													onChange={handleTimeRangeChange}
													chartId="topDoctorsByConsultation"
												/>
											</div>
											<div className="row  w-100 " style={{ paddingLeft: '50px', paddingRight: '50px' }}>
												<div className="col-sm-12">
													<div className="element-wrapper">
														<h6 className="element-header">Consultation Ranking by Staff</h6>

														<p className="chart-description card p-2 " style={{ fontSize: '14px', color: '#666', marginBottom: '10px' }}>
															High-level metrics showing overall metrics of reading over time.
														</p>
														<div className="element-box">
															{/* <TableLoading /> */}

															<Row gutter={16}>
																<Col span={8}>
																	<Card>
																		<Statistic title="Total" value={staffRankingBottom?.length} suffix="" />
																		<small className="text-muted">Total Clinical Tasks</small>
																	</Card>
																</Col>
																{/* <Col span={8}>
														<Card>
															<Statistic
																title="Total Revenue"
																value={transSummary?.totalRevenueFormatted} suffix=""
															/>

															<small className="text-muted">Cumulative Revenue From --- to --</small>
														</Card>
													</Col>
													<Col span={8}>
														<Card>
															<Statistic
																title="Total Transactions"
																value={transSummary?.totalTransactions} suffix=""
															/>
															<Statistic
																					title="Survey Coverage Rate"
																					value={coverageRate > 0 ? (coverageRate).toFixed(1) : 0}
																					suffix=""
																				/>
															<small className="text-muted">Cumulative Transactions From --- to --</small>
														</Card>
													</Col> */}
																{/* <Col span={6}>
																		<Card>
																			<Statistic title="Lowest Scoring Area" value={0} suffix="/3" />
																			<small className="text-muted">Needs attention</small>
																		</Card>
																	</Col> */}
															</Row>
														</div>
													</div>
												</div>
											</div>

											<div className=" " style={{ marginLeft: '50px', marginRight: '50px' }}>
												<p className="chart-description card p-2">
													This chart Ranks doctors performance by consultations, helping identify areas for improvement.
												</p>
											</div>

											<div className=" " style={{ marginLeft: '50px', marginRight: '50px' }}>
												<div className=" card w-100 ">
													<div className="row">
														<div className="col-md-12 mb-4">
															<div className="card h-100">
																<div className="card-body">
																	{loadingStates.staffRanking ? (
																		<TableLoading />
																	) : staffRankingBottom?.length > 0 ? (
																		<div style={{ width: '100%', height: 'auto' }}>
																			{staffRankingBottom?.length > 45 ? (
																				<ResponsiveContainer width="100%" height={staffRankingBottom?.length * 40}>
																					<BarChart
																						data={staffRankingBottom}
																						layout="vertical"
																						margin={{ top: 20, right: 30, left: 80, bottom: 20 }}
																					>
																						<CartesianGrid strokeDasharray="5 5" />

																						{/* Categories on Y axis */}
																						<YAxis
																							type="category"
																							dataKey="name"
																							tick={{ fontSize: 12 }}
																							width={120}
																							tickFormatter={value => {
																								const truncated = value.length > 15 ? value.substring(0, 15) + '...' : value;
																								const capitalized = truncated
																									.toLowerCase()
																									.split(' ')
																									.map(word => word.charAt(0).toUpperCase() + word.slice(1))
																									.join(' ');
																								return capitalized;
																							}}
																						/>

																						{/* Values on X axis */}
																						<XAxis type="number" domain={[0, 'auto']} />

																						<Tooltip
																							formatter={value => Number(value).toLocaleString()}
																							labelFormatter={label => String(label).charAt(0).toUpperCase() + String(label).slice(1)}
																						/>
																						{/* <Legend /> */}

																						<Bar dataKey="count">
																							{staffRankingBottom.map((entry, index) => (
																								<Cell key={`cell-${index}`} fill={COLORSe[entry.type] || 'blue'} />
																							))}
																							<LabelList dataKey="count" position="right" content={formatBarLabel} />
																						</Bar>
																					</BarChart>
																				</ResponsiveContainer>
																			) : (
																				<ResponsiveContainer width="100%" height={400}>
																					<BarChart data={staffRankingBottom} margin={{ top: 20, right: 30, left: 20, bottom: 40 }}>
																						<CartesianGrid strokeDasharray="5 5" />
																						<XAxis
																							dataKey={'name'}
																							angle={-45}
																							textAnchor="end"
																							fontSize={12}
																							interval={0}
																							tickFormatter={value => {
																								const truncated = value.length > 15 ? value.substring(0, 15) + '...' : value;
																								const capitalized = truncated
																									.toLowerCase()
																									.split(' ')
																									.map(word => word.charAt(0).toUpperCase() + word.slice(1))
																									.join(' ');
																								return capitalized;
																							}}
																						/>
																						<YAxis domain={[0, 'auto']} />
																						<Tooltip
																							formatter={value => Number(value).toLocaleString()}
																							labelFormatter={label => String(label).charAt(0).toUpperCase() + String(label).slice(1)}
																						/>
																						<Legend wrapperStyle={{ marginBottom: '-45px' }} />
																						<Bar dataKey="count">
																							{staffRankingBottom.map((entry, index) => (
																								<Cell key={`cell-${index}`} fill={COLORSe[entry.type] || 'blue'} />
																							))}
																							<LabelList dataKey="count" position="top" content={formatBarLabel} />
																						</Bar>
																					</BarChart>
																				</ResponsiveContainer>
																			)}
																		</div>
																	) : (
																		<div className="text-center fs-bold">No Record Found!</div>
																	)}
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</SlidingPane>
								</div>
							</div>
						</div>

						{/* Appointment TAT */}
						<div className="row">
							<div className="col-sm-12">
								<div className="element-wrapper">
									<div className="d-flex justify-content-between align-items-center">
										<h6 className="element-header">Appointment Turn Around Time</h6>
										<div className="d-flex justify-content-end w-100">
											<div>
												<div
													style={{ width: '100px', cursor: 'pointer', textAlign: 'center' }}
													onClick={() => setModalAlt(true)}
													className="form-control form-control-sm text-white bg-primary rounded"
												>
													View All
												</div>
											</div>
											&nbsp;
											<TimeRangeDropdownAlt3 value={timeRanges?.appointmentTAT} onChange={handleTimeRangeChange} chartId="appointmentTAT" />
										</div>
									</div>
									<p className="chart-description card p-2">This charts shows appointment turn around time for the selected time range.</p>
									<div className="element-box">
										{loadingStates.appointmentTAT ? (
											<TableLoading />
										) : appointmentTAT?.groups?.length > 0 ? (
											<div style={{ height: '400px' }}>
												<ResponsiveContainer width="100%" height={400}>
													<LineChart data={appointmentTAT?.groups.slice(0, 10)} margin={{ top: 20, right: 30, left: 20, bottom: 40 }}>
														<CartesianGrid strokeDasharray="3 3" />
														<XAxis
															angle={-45}
															dataKey="name"
															tick={{ fontSize: 12 }}
															width={120}
															tickMargin={20}
															tickFormatter={value => {
																const truncated = value.length > 10 ? value.substring(0, 10) + '...' : value;
																const capitalized = truncated
																	.toLowerCase()
																	.split(' ')
																	.map(word => word.charAt(0).toUpperCase() + word.slice(1))
																	.join(' ');
																return capitalized;
															}}
														/>

														<YAxis domain={[0, 'auto']} />

														<Tooltip content={<CustomTooltipTAT />} />

														<Legend wrapperStyle={{ marginBottom: '-50px' }} />
														<Line type="monotone" dataKey="count" stroke="#8884d8" />
														{/* <Line type="monotone" dataKey="Median" stroke="none" dot={false} activeDot={false} />
														<Line type="monotone" dataKey="Min" stroke="none" dot={false} activeDot={false} />
														<Line type="monotone" dataKey="Max" stroke="none" dot={false} activeDot={false} /> */}
													</LineChart>
												</ResponsiveContainer>
											</div>
										) : (
											<div className="text-center fs-bold">No Record Found!</div>
										)}
									</div>
								</div>
							</div>

							<SlidingPane isOpen={modalAlt}>
								<div className=" content-box">
									<div className=" d-flex justify-content-end w-100">
										<button className="btn btn-danger float-end" onClick={() => setModalAlt(false)}>
											&times;
										</button>
									</div>

									<div className=" d-flex justify-content-end mt-5 t-5 align-items-center">
										<TimeRangeDropdownAlt3 value={timeRanges?.appointmentTAT} onChange={handleTimeRangeChange} chartId="appointmentTAT" />
									</div>
									<div className="row  w-100 " style={{ paddingLeft: '50px', paddingRight: '50px' }}>
										<div className="col-sm-12">
											<div className="element-wrapper">
												<h6 className="element-header">Appointment Turn Around Time</h6>
											</div>
										</div>
									</div>

									<div className=" " style={{ marginLeft: '50px', marginRight: '50px' }}>
										<p className="chart-description card p-2">
											This charts shows appointment turn around time for the selected time range.
										</p>
									</div>

									<div className=" " style={{ marginLeft: '50px', marginRight: '50px' }}>
										<div className=" card w-100 ">
											<div className="row">
												<div className="col-md-12 mb-4">
													<div className="card h-100">
														<div className="card-body">
															{loadingStates.appointmentTAT ? (
																<TableLoading />
															) : appointmentTAT ? (
																<div style={{ width: '100%', height: 400 }}>
																	<ResponsiveContainer width="100%" height={400}>
																		<LineChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 40 }}>
																			<CartesianGrid strokeDasharray="3 3" />
																			<XAxis
																				angle={-45}
																				dataKey="name"
																				tick={{ fontSize: 12 }}
																				width={120}
																				tickMargin={20}
																				tickFormatter={value => {
																					const truncated = value.length > 10 ? value.substring(0, 10) + '...' : value;
																					const capitalized = truncated
																						.toLowerCase()
																						.split(' ')
																						.map(word => word.charAt(0).toUpperCase() + word.slice(1))
																						.join(' ');
																					return capitalized;
																				}}
																			/>

																			<YAxis dataKey="Average" />
																			<Tooltip />
																			<Legend wrapperStyle={{ marginBottom: '-50px' }} />
																			<Line type="monotone" dataKey="Average" stroke="#8884d8" />
																			<Line type="monotone" dataKey="Median" stroke="none" dot={false} activeDot={false} />
																			<Line type="monotone" dataKey="Min" stroke="none" dot={false} activeDot={false} />
																			<Line type="monotone" dataKey="Max" stroke="none" dot={false} activeDot={false} />
																		</LineChart>
																	</ResponsiveContainer>
																</div>
															) : (
																<div className="text-center fs-bold">No Record Found!</div>
															)}
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</SlidingPane>
						</div>

						<div className="col-sm-12 ">
							<div className="element-wrapper">
								<h6 className="element-header">Staff Activity Trends </h6>
								<div className="d-flex justify-content-end w-100">
									<TimeRangeDropdownAlt3 value={timeRanges.requestCount} onChange={handleTimeRangeChange} chartId="requestCount" />
								</div>
								<p className="chart-description mb-3 p-2 card">This chart shows staff activity trends.</p>

								<div className="element-box">
									{loadingStates?.requestCount ? (
										<TableLoading />
									) : requestCount?.length > 0 ? (
										<div style={{ height: '400px' }}>
											<ResponsiveContainer>
												<LineChart data={requestCount} margin={{ top: 20, right: 20, left: 10, bottom: 20 }}>
													<CartesianGrid strokeDasharray="3 3" />
													<XAxis
														dataKey={'name'}
														angle={-45}
														textAnchor="end"
														fontSize={12}
														interval={0}
														tickFormatter={value => {
															const truncated = value.length > 10 ? value.substring(0, 10) + '...' : value;
															const capitalized = truncated
																.toLowerCase()
																.split(' ')
																.map(word => word.charAt(0).toUpperCase() + word.slice(1))
																.join(' ');
															return capitalized;
														}}
													/>
													<YAxis domain={[0, 'auto']} />
													<Tooltip
													// formatter={value => formatDuration(value)}
													// labelFormatter={label => String(label).charAt(0).toUpperCase() + String(label).slice(1)}
													/>
													<Legend wrapperStyle={{ marginBottom: '-45px' }} />
													<Line
														type="monotone"
														dataKey="value"
														name="count"
														stroke="#22BB33"
														strokeWidth={2}
														dot={{ r: 4 }}
														activeDot={{ r: 6 }}
													>
														<LabelList
															dataKey="value"
															name="count"
															// content={renderCustomLabelAlt}
															position="top"
															style={{ fontSize: '10px', fill: '#333' }}
														/>
													</Line>
												</LineChart>
											</ResponsiveContainer>
										</div>
									) : (
										<div className="text-center fs-bold">No Record Found!</div>
									)}
								</div>
							</div>
						</div>
					</div>
				);
			case 'antenatal':
				return <AntenatalOverview />;
			case 'ivf':
				return <IVFOverview />;
			case 'Admission':
				return <AdmissionOverview />;
			case 'Procedure':
				return <ProcedureOverview hide={true} />;
			default:
				return <div>Select a report type</div>;
		}
	};

	const COLORSe = {
		appointment: '#8884d8',
		registration: '#82ca9d',
	};

	// Custom tooltip
	const CustomTooltip = ({ active, payload, label }) => {
		if (active && payload && payload.length) {
			return (
				<div className="custom-tooltip bg-white p-3 shadow rounded">
					<p className="font-weight-bold mb-2 text-capitalize">{payload[0]?.payload?.name || label}</p>
					{payload.map((entry, index) => (
						<p key={`item-${index}`} style={{ color: entry.color || '#000' }}>
							{`${entry.name}: ${entry.value}`}
							{entry.dataKey === 'avgTime' && ' mins'}
							{entry.dataKey === 'satisfaction' && '%'}
						</p>
					))}
					{payload[0]?.payload?.specialty && <p className="text-muted">Specialty: {payload[0].payload.specialty}</p>}
				</div>
			);
		}
		return null;
	};

	const CustomTooltipAlt = ({ active, payload, label }) => {
		if (active && payload && payload.length) {
			const data = payload[0].payload; // the whole row object
			return (
				<div className="custom-tooltip" style={{ background: '#fff', border: '1px solid #ccc', padding: '8px' }}>
					<p>
						<strong>Date:</strong> {label}
					</p>
					<p>
						<strong>Initial:</strong> {data.initial?.toLocaleString()}
					</p>
					<p>
						<strong>Follow-up:</strong> {data.follow_Up?.toLocaleString()}
					</p>
					<p>
						<strong>Review:</strong> {data.review?.toLocaleString()}
					</p>
					<p>
						<strong>Total:</strong> {data.total?.toLocaleString()}
					</p>{' '}
				</div>
			);
		}
		return null;
	};

	const CustomTooltipTAT = ({ active, payload, label }) => {
		if (active && payload && payload.length) {
			const data = payload[0].payload; // the whole row object
			return (
				<div className="custom-tooltip" style={{ background: '#fff', border: '1px solid #ccc', padding: '8px' }}>
					{/* {JSON.stringify(data)} */}
					<p>
						<strong>Name:</strong> {label}
					</p>
					<p>
						<strong>Count:</strong> {data.count?.toLocaleString()} <span>Number of encounter</span>
					</p>
					<p>
						<strong>Avaerage TAT:</strong> {data.averageTAT?.formatted?.toLocaleString()}
					</p>
					<p>
						<strong>Median TAT:</strong> {data.medianTAT?.formatted?.toLocaleString()}
					</p>
					<p>
						<strong>Min TAT:</strong> {data.minTAT?.formatted?.toLocaleString()}
					</p>
					<p>
						<strong>Max TAT:</strong> {data.maxTAT?.formatted?.toLocaleString()}
					</p>{' '}
				</div>
			);
		}
		return null;
	};

	return (
		<div className="content-">
			<div className="content-bo">
				<div className="element-wrapper">
					<h6 className="element-header">Doctor's Overview</h6>
					<div className="element-box">
						<div className="os-tabs-w mx-1">
							<div className="os-tabs-controls os-tabs-complex">
								<ul className="nav nav-tabs upper d-flex gap-3 ms-2">
									{[
										{ key: 'doctor', label: 'Doctor' },
										{ key: 'antenatal', label: 'Antenatal' },
										{ key: 'ivf', label: 'IVF' },
										{ key: 'Admission', label: 'Admission' },
										{ key: 'Procedure', label: 'Procedure' },
									].map(tab => (
										<li key={tab.key} className="nav-item">
											<button
												type="button"
												onClick={() => setActiveTab(tab.key)}
												className={`nav-link text-capitalize ${activeTab === tab.key ? 'active' : ''}`}
											>
												{tab.label}
											</button>
										</li>
									))}
								</ul>
							</div>
						</div>

						<div className="col-sm-12"></div>
						{renderReport()}
					</div>
				</div>
			</div>
		</div>
	);
};

export default DoctorOverview;
